import { createContext, ReactNode, useState } from 'react'

interface LoadingContext {
  loading: boolean
  setLoading: (loading: boolean) => void
}
export const LoadingContext = createContext<LoadingContext>({
  loading: false,
  setLoading: () => {}
})
interface Props {
  children: ReactNode
}
const LoadingContextProvider = ({ children }: Props) => {
  const [loading, setLoading] = useState<boolean>(false)
  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoadingContext.Provider>
  )
}

export default LoadingContextProvider
